import { useNavigate } from "@tanstack/react-router";

import { CaseSchema } from "@api/generated/types.gen";

import { CasesList } from "@components/CasesList";
import { PageHeader } from "@components/PageHeader";

import { NAVIGATION_PATHS } from "@constants/navigation";

const ReportStudioPage = () => {
  const navigate = useNavigate();

  const handleRowClick = (caseItem: CaseSchema) => {
    navigate({
      to: `${NAVIGATION_PATHS.REPORT_STUDIO}/${caseItem.case_number}`,
    });
  };

  return (
    <div className="space-y-4 px-10 py-8">
      <PageHeader title="Report Studio" description="All cases are here!" />

      <CasesList onRowClick={handleRowClick} />
    </div>
  );
};

export default ReportStudioPage;
